<lp-mein-profil-row label="Funktionen" i18n-label="@@common.funktionen">
  <div class="dm-flex dm-flex-wrap dm-gap-6" role="list" [attr.aria-label]="funktionenLabel">
    @for (funktion of assignedFunktionen(); track funktion.intId) {
      <dm-badge role="listitem" dmType="modern" color="gray-blue" size="md">{{ funktion.label }}</dm-badge>
    }
  </div>
</lp-mein-profil-row>
